import { originItems } from "../data";
import SectionHead from "./SectionHead";

export default function Origin() {
  return (
    <section id="origin" className="border-y border-background-200/70 bg-background-100 py-14 md:py-20">
      <div className="wrap grid items-start gap-10 lg:grid-cols-[0.9fr_1.1fr]">
        <SectionHead
          no="04"
          title="它的「由来」有几种说法"
          desc="和大多数数字梗一样，吃瓜91 没有一个被所有人承认的单一出处。下面整理的是网上比较常被提到的三种讲法，当作理解的角度即可。"
          tone="secondary"
        />

        <ol className="relative ml-2 space-y-6 border-l border-background-300 pl-6">
          {originItems.map((o) => (
            <li key={o.no} className="relative">
              <span className="absolute -left-[31px] top-1 inline-flex h-4 w-4 items-center justify-center rounded-full bg-accent-500 ring-4 ring-accent-100" />
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center rounded-full bg-background-200 px-2.5 py-0.5 text-xs font-semibold text-foreground-800">
                  {o.no}
                </span>
                <h3 className="eyebrow text-lg font-bold text-foreground-950">{o.title}</h3>
              </div>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{o.summary}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-700">
                <i className="ri-sparkling-line h-3.5 w-3.5 flex items-center justify-center" />
                {o.tag}
              </span>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}